import * as React from 'react';
import { SPopover } from './Popover.styles';
import { TPopoverProps } from './Popover.types';

const Popover = (props: TPopoverProps) => {
  return <SPopover {...props} />;
};

export default Popover;
